import React, {useState} from 'react';
import {Box} from '@mui/material';
import {ISelectItem} from '../../shared/types';
import './CommentsList.scss';
import {CommentsListGrid} from './components/comments-list-grid/CommentsListGrid';
import ManageHeader from '../components/manage-header/ManageHeader';
import {t} from 'i18next';

const CommentsList: React.FC = () => {
  const [selectedGroup, setSelectedGroup] = useState<ISelectItem | null>(null);

  return (
    <Box className="comments-list-container">
      <ManageHeader
        title={t('manageCommentFields.title')}
        infoContentTitle={t('manageCommentFields.headerTooltip.title')}
        infoContent={'manageCommentFields.headerTooltip.content'}
        onChangeGroup={setSelectedGroup}
      />
      <CommentsListGrid selectedGroup={selectedGroup} />
    </Box>
  );
};

export default CommentsList;
